export const MinLabelIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
            <path
                fill="url(#a)"
                d="M14.48 9.406a.491.491 0 0 0 .5-.52 7 7 0 0 0-13.96 0 .491.491 0 0 0 .5.52.558.558 0 0 0 .543-.52 5.96 5.96 0 0 1 11.874 0c.025.286.256.52.543.52Z"
            />
            <path stroke="#002F63" d="M9.854 12.18a2 2 0 1 1-2.828-2.828 2 2 0 0 1 2.828 2.828Z" />
            <rect
                width={1}
                height={4.691}
                fill="url(#b)"
                rx={0.5}
                transform="scale(-1 1) rotate(45 -9.282 -2.226)"
            />
            <defs>
                <linearGradient
                    id="a"
                    x1={2.255}
                    x2={13.44}
                    y1={6.532}
                    y2={6.791}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#D43527" />
                    <stop offset={0.245} stopColor="#002F63" />
                </linearGradient>
                <linearGradient
                    id="b"
                    x1={0.5}
                    x2={0.5}
                    y1={0}
                    y2={4.691}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#D43527" />
                    <stop offset={1} stopColor="#002F63" />
                </linearGradient>
            </defs>
        </svg>
    );
};
